import { useState } from 'react';

import { useGetPaymentsStatsQuery } from '@/modules/payments';
import { useShowResponseStatus } from '@/shared';

import type { TGetPaymentsStatsParams } from '../store/types';

const initialParams: TGetPaymentsStatsParams = {};

export const useGetPaymentsStats = (initialFilter: TGetPaymentsStatsParams = initialParams) => {
  const [params, setParams] = useState<TGetPaymentsStatsParams>(initialFilter);
  const { data, isLoading, isError } = useGetPaymentsStatsQuery(params);

  const handleFilterChange = (data: TGetPaymentsStatsParams) => {
    setParams({ ...initialParams, ...data });
  };

  const handleFilterReset = () => {
    setParams({ ...initialFilter });
  };

  useShowResponseStatus({
    isError,
    errorMassage: 'Произошла ошибка!',
  });

  return {
    data,
    isLoading,
    handleFilterChange,
    handleFilterReset,
  };
};
